import { customAttribute, autoinject } from 'aurelia-framework';
import { activationStrategy } from 'aurelia-router';

@autoinject
@customAttribute('unselectable')
export class Unselectable {
    element: Element;
    value: boolean = false;

    constructor(element: Element) {
        this.element = element;
    }

    bind() {
        if (!this.value) {
            this.element.setAttribute('unselectable', 'on');
        }
    }
}